export default __webpack_public_path__ + "static/media/tram.2d5ca0b1.png";